
































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import SpectrumDiagramBox from '@c/diagrams/SpectrumDiagramBox.vue';
import {DiagramData, SignalDiagramData, SpectrumDiagramData} from '@c/diagrams/interfaces';
import CompareDiagramButtonDialog from '@/components/services/diagnosticAssistance/CompareDiagramButtonDialog.vue';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {DtcpAccelerometerModule, PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import dtcpAccelerometerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpAccelerometerStoreModule';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';
import {Freqband} from '@/interfaces/diagrams';
import {VibrationDiagnosticAction} from '@v/services/vibrationDiagnostic/enums';
import Card from '@c/Card.vue';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import VibrationDiagramBox from '@c/services/vibrationDiagnostic/VibrationDiagramBox.vue';
import VibrationWaterfallBox from '@c/services/vibrationDiagnostic/VibrationWaterfallBox.vue';
import DiagramsToCompareBox from '@c/diagrams/DiagramsToCompareBox.vue';
import AngleDiagramBox from '@c/diagrams/AngleDiagramBox.vue';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {
    SpectrumDiagramBox,
    CompareDiagramButtonDialog,
    Card,
    SignalDiagramBox,
    VibrationDiagramBox,
    VibrationWaterfallBox,
    DiagramsToCompareBox,
    AngleDiagramBox,
  },
})
export default class DAssistanceSpectrumDiagramBox extends Vue {
  // Текущая диаграмма
  @Prop({required: true})
  diagram!: DiagramData;

  // Список диаграмм для сравнения
  @Prop({required: true})
  diagrams!: DiagramData[];

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Список выбранных диаграмм
  selectedDiagrams: DiagramData[] = [];

  //Действия при выборе программных модулей
  onSelect(diagramIds: string[]) {
    this.selectedDiagrams = this.diagrams.filter(x => diagramIds.includes(x.id));
  }

  selectedAccelerometerId: number | null = null;
  // Диаграммы спектров
  diagramsToCompare: any[] = [];
  // Показатель режима редактирования
  edit = false;
  //Список графиков, которые должны быть показаны в отдельных диаграммах
  detachedSignalDiagrams: SignalDiagramData[] = [];

  freqbands: Freqband[] = [];
  dtcpAccelerometerModules: any = {};

  span_nodes: any[] | null = null;

  // Диаграммы спектров
  spectrumDiagrams: {
    itemFreqbands: Freqband[];
    mainDiagram: SpectrumDiagramData;
    comparedDiagrams: SpectrumDiagramData[];
  }[] = [];

  showDiagramsToCompareLegendMenu = false;

  //Координаты меню при клике на элемент легенды
  xLegendMenu = 0;
  yLegendMenu = 0;

  //хак для корректного отображения меню
  keyMenu = 0;

  //идентификтор диаграммы для которой необходимо показать меню
  clickedDiagramId!: string;
  clickedDiagramIndex!: any;

  diagramsToCompareItemsLegendMenu = [
    {action: VibrationDiagnosticAction.ChangeVisibility, title: ''},
    {action: VibrationDiagnosticAction.Delete, title: 'Удалить'},
  ];

  clickedDiagramToCompareVisibility = true;
  selectedAccelerometerGUID = '';

  // создаём диаграмму только когда получены нужные данные
  loaded = false;

  diagramsKey = 0;

  // Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  // Получить наименование для строки таблицы freqband в зависимости от значений в ней
  getNameFreqbandItem(central_frequency?: number, bandwidth?: number) {
    const cf = central_frequency ? `ц.ч. ${central_frequency}` : '';
    const bw = bandwidth ? `ш.п. ${bandwidth}` : '';
    return cf ? `${cf}${bw ? ';' : ''} ${bw}` : bw;
  }

  async addToCompare(diagram: any, timestamp: any) {
    const element = {...diagram};
    element.time = timestamp;
    element.freqbands = this.freqbands;
    element.visible = true;

    this.selectedAccelerometerGUID = element.moduleGUID;
    this.selectedAccelerometerId = element.moduleId;

    const index = this.diagramsToCompare.findIndex(x => x[0].id == element.id);
    if (index != -1) {
      if (!this.diagramsToCompare[index].map((x: any) => x.time).includes(element.time))
        this.diagramsToCompare[index].push(element);
    } else {
      const array = [];
      array.push(element);
      this.diagramsToCompare.push(array);
    }
    this.diagramsKey++;
  }

  onRemoveDiagramToCompare(diagram: any) {
    this.diagramsToCompare = this.diagramsToCompare.filter(d => d[0].id != diagram[0].id);

    if (
      !this.detachedSignalDiagrams.length &&
      !this.spectrumDiagrams.length &&
      !this.diagramsToCompare.length
    )
      this.edit = false;
  }

  diagramToCompareSpectrumRemove() {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == this.clickedDiagramId);
    const diagram = this.diagramsToCompare[index][this.clickedDiagramIndex];
    this.diagramsToCompare[index] = this.diagramsToCompare[index].filter((x: any) => x != diagram);
    if (!this.diagramsToCompare[index].length)
      this.diagramsToCompare = this.diagramsToCompare.filter(
        x => this.diagramsToCompare.indexOf(x) != this.diagramsToCompare[index],
      );
    this.showDiagramsToCompareLegendMenu = false;
  }

  changeDiagramToCompareVisibility(visible: any) {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == this.clickedDiagramId);
    this.diagramsToCompare[index][this.clickedDiagramIndex].visible = visible;
    this.showDiagramsToCompareLegendMenu = false;
    this.diagramsKey++;
  }

  onDiagramToCompareMenuItemClicked(item: any) {
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.Delete) {
      this.diagramToCompareSpectrumRemove();
    }
    if (this.clickedDiagramId && item.action === VibrationDiagnosticAction.ChangeVisibility) {
      this.changeDiagramToCompareVisibility(!this.clickedDiagramToCompareVisibility);
    }
  }

  addNewSpectrums(timestamps: any, id: any) {
    const index = this.diagramsToCompare.findIndex(x => x[0].id == id);
    timestamps.forEach((timestamp: any) => {
      const diagram = {...this.diagramsToCompare[index][0]};
      diagram.time = timestamp;
      diagram.visible = true;
      this.diagramsToCompare[index].push(diagram);
    });
    this.diagramsKey++;
  }

  onDiagramsToCompareItemLegendClicked(data: {id: string; index: any; x: number; y: number}) {
    this.showDiagramsToCompareLegendMenu = false;
    const diagrams = this.diagramsToCompare.find(x => x[0].id == data.id);
    const diagram = diagrams[data.index];

    this.xLegendMenu = data.x;
    this.yLegendMenu = data.y;
    this.clickedDiagramId = data.id;
    this.clickedDiagramIndex = data.index;
    this.clickedDiagramToCompareVisibility = diagram.visible;
    this.$nextTick(() => {
      this.keyMenu++;
      this.showDiagramsToCompareLegendMenu = true;
    });
  }

  getEnvelopeDoctaveItems(
    name: 'envelope_3doctave' | 'envelope_1doctave',
    pmodule: DtcpAccelerometerModule,
  ): {central: number; width: number}[] {
    const base2 = pmodule[name].toString(2);
    const base2Length = base2.length - 1;
    let data: any[] = [];
    const module = this.dtcpAccelerometerModules.find(
      (item: any) => item.id === pmodule.sensor_type,
    );
    if (module) {
      data = module[name];
    }

    data = data
      .map(item => {
        return {
          ...item,
          isActive: base2[base2Length - item.bit] === '1',
          width: item.max - item.min,
        };
      })
      .filter(item => item.isActive);

    return data;
  }

  getEnvelopeThreeDoctaveItems(pmodule: DtcpAccelerometerModule) {
    return this.getEnvelopeDoctaveItems('envelope_3doctave', pmodule);
  }

  getEnvelopeOneDoctaveItems(pmodule: DtcpAccelerometerModule) {
    return this.getEnvelopeDoctaveItems('envelope_1doctave', pmodule);
  }

  async created() {
    try {
      const {data: dtcpAccelerometerModules} = await httpClient.get(
        `/dtcp-accelerometer-modules/sensor-types/`,
      );
      this.dtcpAccelerometerModules = dtcpAccelerometerModules;
      this.freqbands = await this.loadFreqbands(this.diagram.moduleId, this.diagram.moduleType);
      this.loaded = true;
    } catch (e) {
      console.log(e);
    }

    try {
      const {data} = await dtcpAccelerometerStoreModule.getById(this.diagram.moduleId);
      this.span_nodes = (data as PModuleWithMeasurements).span_nodes?.filter(
        (n: any) => !n.is_deleted,
      );

      if (this.span_nodes) {
        if (!dtcpTahoModule.all.length) {
          await dtcpTahoModule.fetchAll();
        }
        this.span_nodes = this.span_nodes.map((n: any) => {
          if (n.is_deleted) return n;
          if (!n.taho_module_uuid) return n;
          const taho = dtcpTahoModule.all.find(m => m.guid == n.taho_module_uuid);
          const newval = {
            ...n,
            taho_module: taho,
          };
          return newval;
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  // Загрузка Freqbands для модуля
  async loadFreqbands(moduleId: number, moduleType: PModuleType) {
    if (moduleId === undefined) {
      return [];
    }
    // const spectrumApiStore = dtcpAccelerometerModule;
    const spectrumApiStore = (pmoduleStoresByTypeMap.get(
      (moduleType as any) as PModuleType,
    ) as any) as PModuleStoreModule;
    if (!spectrumApiStore) {
      // не реализованы стор для соотв модуля
      return [];
    }

    const {data} = await spectrumApiStore.getById(moduleId);
    if (data) {
      return [
        ...this.getEnvelopeThreeDoctaveItems(data as DtcpAccelerometerModule),
        ...this.getEnvelopeOneDoctaveItems(data as DtcpAccelerometerModule),
      ].map(item => {
        return {
          id: Math.random(),
          central_frequency: item.central,
          bandwidth: item.width,
          name: this.getNameFreqbandItem(item.central, item.width),
        };
      });
    }

    return [];
  }
}
